import { readStaffAppContext } from '../clinic/seed';
import { card, el } from '../dom';

export function renderPlaceholder(options: {
  readonly title: string;
  readonly section: string;
  readonly body: string;
}): (mount: HTMLElement) => void {
  return (mount) => {
    const context = readStaffAppContext();
    mount.append(
      el(
        'section',
        { class: 'section' },
        el('h2', {}, options.title),
        el('p', { class: 'lede' }, options.body),
      ),
      card({
        title: 'Preview stub',
        tone: 'pending',
        toneLabel: 'Not built',
        body: 'This slice ships the staff shell and location context only. The destination is a placeholder so the left nav can match Lovable without inventing Calendar, POS, or Service Center.',
        facts: [
          ['Section', options.section],
          ['Location', context ? `${context.location.name} (${context.location.code})` : 'none'],
          ['Preview role', context?.actor.roleTitle ?? 'none'],
          ['Actor', context?.actor.displayName ?? 'none'],
        ],
      }),
    );
  };
}
